/**
 * axios setup to use mock service
 */

import axios, { AxiosRequestConfig } from 'axios';

const axiosServices = axios.create({ baseURL: import.meta.env.VITE_APP_API_URL || 'http://localhost:3010/', withCredentials: true });

// ==============================|| AXIOS - FOR MOCK SERVICES ||============================== //

axiosServices.interceptors.request.use(
    async (config) => {
        const accessToken = localStorage.getItem('serviceToken');
        if (accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// axiosServices.interceptors.response.use(
//     (response) => response,
//     (error) => {
//         if (error.response.status === 401 && !window.location.href.includes('/login')) {
//             window.location.pathname = '/login';
//         }
//         return Promise.reject((error.response && error.response.data) || 'Wrong Services');
//     }
// );
// axiosServices.interceptors.response.use(
//     (response) => {
//         return response;
//     },
//     async (error) => {
//         const originalRequest = error.config;
//         if (error.response.status === 401 && !originalRequest._retry) {
//             originalRequest._retry = true;
//             // const refreshToken = localStorage.getItem('refreshToken');
//             // if (refreshToken) {
//             try {
//                 const response = await axiosServices.get(`/auth/refreshtoken`);
//                 // don't use axious instance that already configured for refresh token api call
//                 const newAccessToken = response.data.body.accessToken;
//                 localStorage.setItem('serviceToken', newAccessToken); //set new access token
//                 originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
//                 return axios(originalRequest); //recall Api with new token
//             } catch (error) {
//                 return Promise.reject(error);
//             }
//             // }
//         }
//         return Promise.reject(error);
//     }
// );

export default axiosServices;

export const fetcher = async (args: string | [string, AxiosRequestConfig]) => {
    const [url, config] = Array.isArray(args) ? args : [args];

    const res = await axiosServices.get(url, { ...config });

    return res.data;
};
